export default "__VITE_ASSET__DVlF0iyO__"